type PaymentOption = {
  provider: string
}

export function isDepositPaymentOption({provider}: PaymentOption): boolean {
  return provider === 'enovipayCoinspaid'
}

/**
 * The minimum a deposit into a factorised Tauro account must reach (PT-7173). The backend puts
 * the campaign minimum qualifying deposit into the account minimum, in the account currency. The
 * regular rule may pick the lower client minimum instead, so an unfunded factorised account never
 * goes below the account minimum. A funded account takes no deposit and the backend adds no
 * campaign minimum for it.
 */
export function applyTauroMinimumDeposit(
  minimumDeposit: number,
  isUnfundedFactorised: boolean,
  accountMinimumDeposit: number | null | undefined,
): number {
  if (!isUnfundedFactorised || !accountMinimumDeposit) return minimumDeposit
  return Math.max(minimumDeposit, accountMinimumDeposit)
}

/**
 * The upper bound of one deposit in the account currency (PT-7175). Only an unfunded factorised
 * Tauro account has one: the campaign maximum qualifying deposit. The commit step refuses a larger
 * deposit after the payment provider has already taken the money, so the form stops it first.
 */
export function isAboveMaximumDeposit(
  amount: number | string,
  maximumDeposit: number | null | undefined,
): boolean {
  if (maximumDeposit == null || !(maximumDeposit > 0)) return false
  return +amount > maximumDeposit
}

/**
 * Drops the deposit buttons above the account maximum (PT-7175). A regular account has no maximum
 * and keeps every button. When no button fits under the maximum, the maximum is the only button.
 */
export function capPrefilledAmounts(
  amounts: number[],
  maximumDeposit: number | null | undefined,
): number[] {
  if (maximumDeposit == null || !(maximumDeposit > 0)) return amounts
  const fitting = amounts.filter((amount) => amount <= maximumDeposit)
  return fitting.length > 0 ? fitting : [maximumDeposit]
}
